"use client";

import { CornerUpLeft } from "lucide-react";
import { useRouter } from "next/navigation";

type BackButtonProps = {
  fallbackHref?: string;
  label?: string;
};

export function BackButton({
  fallbackHref = "/",
  label = "Vissza",
}: BackButtonProps) {
  const router = useRouter();

  function handleClick() {
    if (window.history.length > 1) {
      router.back();
      return;
    }

    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);

        if (referrerUrl.protocol === "http:" || referrerUrl.protocol === "https:") {
          if (referrerUrl.origin === window.location.origin) {
            router.push(
              `${referrerUrl.pathname}${referrerUrl.search}${referrerUrl.hash}`,
            );
            return;
          }

          window.location.assign(referrerUrl.href);
          return;
        }
      } catch {
        // Ignore invalid referrers and use the local fallback below.
      }
    }

    router.push(fallbackHref);
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-2 rounded-full px-1 py-1 text-sm font-semibold text-[#A4243B] transition-opacity hover:opacity-80"
      aria-label={label}
    >
      <CornerUpLeft className="h-4 w-4" aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
